import React from 'react';
import { createRoot } from 'react-dom/client';

import { FAQAccordion } from '@shared/FAQAccordion';
import { faqListCodeSearch } from '../main-app/data/faq-code-search';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.querySelector('#react-faq-accordion');

  if (node) {
    const root = createRoot(node);
    root.render(
      <FAQAccordion
        faqList={faqListCodeSearch}
        questionFontSize="18px"
        answerFontSize="18px"
        increasedPadding
      />,
    );
  }
});
